// ClassName3 
import { Name3 } from "../../ui/ot";

const ClassName3 = ({

}) => {
    return <>
        <Name3
            propsCategoryName="z3950資料"
            propsCategoryTitle="欄位設定"

            mainApiRoute="/cataloging/backend/z3950_document/view"
            componentDefinitionsApiRoute="/cataloging/backend/z3950_component_definitions"
            componentAttributesApiRoute="/utility/component_attributes"
            selectionApiRoute='/cataloging/backend/z3950_selection'

            dbCoverIdName="z3950_document_id"
            pageFrontendRoute="/cataloging/z3950_document/_3"
            showTabkey={["properties", "setting_tool"]}

        />
    </>
}
export default ClassName3
